<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-09-09 09:18:17
 * @LastEditTime: 2024-09-09 18:40:12
 * @LastEditors:  
-->
<!--
 * @Description: 申请退款
 * @Author:  wang.y
-->
<template>
  <van-popup v-model="modelIndex" position="bottom" round>
    <div class="container-wrapper">
      <div class="line" @click="modelIndex = false"></div>
      <div class="tip-warpper">
        <div class="title">{{'恭喜您！获得赠票' | dealLanguage('Congratulations! Get a free ticket')}}</div>
        <img :src="static_img_url + 'pic/success-icon.png?v=' + $store.state.imgVersion" />
        <p class="p1" v-if="language == 'zh'">您已成功收到 <span>{{count}}</span> 张门票，<br />可在“我的门票”页面中查看门票信息。</p>
            <p class="p1" v-if="language == 'en'">You have successfully received <span>{{count}}</span> ticket. <br />You can view the ticket information on the "My Tickets" page.</p>
      </div>
      <div class="container-bottom ">
        <div class="btns-wrapper">
          <van-button type="primary" block @click="submit">{{'确认' | dealLanguage('Confirm')}}</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { acceptTicket } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  data() {
    return {
      modelIndex: false,
      count: 0,
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    async submit() {
      this.modelIndex = false
      let res = await acceptTicket()
      if (res.code != 0) {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        return
      }
      this.$notify({ type: 'success', message: this.language == 'zh' ? '成功获取门票！' : 'Tickets obtained successfully!' })
      this.$router.push({
        name: 'myTickets',
      })
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/modal-form-m.styl'
.tip-warpper
  padding 1rem 0
  text-align center
  .title
    font-size 0.3rem
    color #333333
    line-height 0.42rem
  img
    width 1.4rem
    height 1.4rem
    margin-top 0.4rem
  .p1
    font-size 0.28rem
    color #3D3D3D
    line-height 0.46rem
    margin-top 0.5rem
    span
      color #C8161D
.btns-wrapper
  padding 0 0.9rem
  .submit-btn
    margin-left 0 !important
</style>
